document.querySelectorAll('[data-social-share]').forEach(function (link) {
  if (link.dataset.socialShareBound) return;
  link.dataset.socialShareBound = '1';

  link.addEventListener('click', function (e) {
    e.preventDefault();
    var url = this.dataset.socialShare;
    var title = this.dataset.shareTitle || '';
    var tooltip = this.closest('.social__copy-wrap').querySelector('.social__copy-tooltip');

    if (navigator.share) {
      navigator.share({ title: title, url: url }).catch(function () {});
    } else {
      navigator.clipboard.writeText(url).then(function () {
        tooltip.classList.add('is-visible');
        setTimeout(function () {
          tooltip.classList.remove('is-visible');
        }, 2000);
      });
    }
  });
});
